// prepareCollectionPageMeta.js
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { BRANDING_NAME } from '../RemoteConfigKeys.js';
import getMetaTagsForHelmet from '../resource/getMetaTagsForHelmet.js';

/**
 * Prepare meta data for collection pages (category, hashtag, etc.)
 * @param {Object} params
 * @param {Object} params.state - Redux state
 * @param {string} params.title - Page title (can be dynamic, e.g., category name)
 * @param {string} params.description - Page description
 * @param {Array<string>} params.keywords - Keywords array
 * @param {string} params.hostname - Request hostname
 * @param {string} params.canonical - Canonical URL
 * @param {Array} params.alternates - Alternate language links
 * @param {Object} params.jsonLd - JSON-LD structured data object (optional)
 * @returns {Promise<Array>} Meta tags array for Helmet
 */
export const prepareCollectionPageMeta = async ({
  state,
  title,
  description,
  keywords = [],
  hostname = 'swag.live',
  canonical = null,
  alternates = null,
  jsonLd = null,
}) => {
  // Get branding name
  const brandingName = getRemoteConfigData(state, BRANDING_NAME) || 'SWAG';

  // Use provided title or fallback to branding name
  const finalTitle = title ? `${title} | ${brandingName}` : brandingName;

  return getMetaTagsForHelmet({
    title: finalTitle,
    description,
    keywords,
    hostname,
    alternates: {
      canonical,
      alternates,
    },
    url: canonical,
    siteName: brandingName,
    jsonLd,
  });
};

export default prepareCollectionPageMeta;
